import * as Flowbite from 'flowbite-react';
import { ComponentPropsWithoutRef } from 'react';
import { BaseProps } from 'shared/Input/types';
import { theme } from './theme';

// Flowbite's ToggleSwitch internally uses a button
type ToggleSwitchProps = BaseProps<boolean> &
    Omit<ComponentPropsWithoutRef<'button'>, 'type' | 'value' | 'onChange'> & {
        label?: string;
        readOnly?: boolean;
    };

export const ToggleSwitch = ({
    value = false,
    onChange = () => {},
    disabled,
    readOnly,
    color = 'primary',
    ...props
}: ToggleSwitchProps) => (
    <Flowbite.ToggleSwitch
        {...props}
        type="button"
        theme={theme}
        color={color}
        checked={value}
        disabled={disabled || readOnly}
        onChange={(checked) => !readOnly && onChange(checked)}
    />
);
